module.exports = __webpack_public_path__ + "img/2022年度全国高质量一张图.2a1406e2.png";